
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emprestimo-fgts",
      function () {
        return require("private-next-pages/emprestimo-fgts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emprestimo-fgts"])
      });
    }
  